import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Gallery from '../components/Gallery';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';

const HomePage = () => {
  useEffect(() => {
    document.title = "Nielsen Brolægning";

    // Update Meta Description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "Nielsen Brolægning er en enkeltmandsvirksomhed drevet af passion for det gode håndværk. Som din personlige brolægger hjælper jeg private boligejere og erhvervskunder med at skabe smukke, holdbare og gennemtænkte udearealer.");

    // Update OG Description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', "Nielsen Brolægning er en enkeltmandsvirksomhed drevet af passion for det gode håndværk. Som din personlige brolægger hjælper jeg private boligejere og erhvervskunder med at skabe smukke, holdbare og gennemtænkte udearealer.");

    // Update OG Image
    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute('content', "https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/80c1e3b3-2080-430e-ba26-768d207f88bf.jpg");

    // Update OG Title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', "Nielsen Brolægning");
  }, []);

  return (
    <>
      <Hero />
      <About />
      <Services />
      <Gallery />
      <Testimonials />
      <Contact />
    </>
  );
};

export default HomePage;
